module.exports = __webpack_public_path__ + "img/avatar-14.27239560.png";